import { render, staticRenderFns } from "./VideoLightbox.vue?vue&type=template&id=32e64571"
import script from "./VideoLightbox.vue?vue&type=script&lang=js"
export * from "./VideoLightbox.vue?vue&type=script&lang=js"
import style0 from "./VideoLightbox.vue?vue&type=style&index=0&id=32e64571&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports